import './u.css';

import 'core-js';
import 'isomorphic-fetch';
import React, {Component} from 'react';
import {render} from 'react-dom';
// import Raven from 'raven-js';
import {Col} from 'jsxstyle';
// import {parse} from 'query-string';
import {Route, Switch, BrowserRouter} from 'react-router-dom';

// const isProd = process.env.NODE_ENV === 'production';
import sensors from 'sa-sdk-javascript';

// if (isProd) {
//   Raven.config('https://3bbb1f7141894dd4b89b39dfaa77a30e@sentry.io/205346', {
//     debug: process.env.NODE_ENV === 'development',
//     release: __webpack_hash__,
//     serverName: parse(window.location.search).u,
//     environment: process.env.NODE_ENV,
//     ignoreErrors: [
//       'AutoBridge',
//       'fb_xd_fragment',
//       /Cannot call method 'exec' of undefined/
//     ],
//     whitelistUrls: [/static\.snaptube\.in/]
//   }).install();
// }

import Auth from './Auth';
import withGA from './withGA';
import {withBundle} from './Bundle';

import loadBattle from 'bundle-loader?lazy!./Battle';
import loadAdha2017 from 'bundle-loader?lazy!./Adha/2017';
import loadSnapKing from 'bundle-loader?lazy!./SnapKing';
import loadLarkGuide from 'bundle-loader?lazy!./LarkGuide';
import loadLarkParty from 'bundle-loader?lazy!./LarkParty';
import loadMillionaires from 'bundle-loader?lazy!./Millionaires';
import lownloadApk from 'bundle-loader?lazy!./Millionaires/DownloadApk';
import jumpMillionaires from 'bundle-loader?lazy!./Millionaires/JumpMillionaires';
import tabMillionaires from 'bundle-loader?lazy!./Millionaires/TabMillionaires';
import loadWorldCup2018 from 'bundle-loader?lazy!./WorldCup/2018';
import loadChristmas2017 from 'bundle-loader?lazy!./Christmas/2017';
import loadSpanishBattle from 'bundle-loader?lazy!./Spanish/Battle';
import loadSpanishEssept from 'bundle-loader?lazy!./Spanish/Essept';
import loadSpanishEssept2 from 'bundle-loader?lazy!./Spanish/Essept2';
import loadSpanishEssept3 from 'bundle-loader?lazy!./Spanish/Essept3';
import loadSpanishEsoct from 'bundle-loader?lazy!./Spanish/Esoct';
import loadSpanishPtoct from 'bundle-loader?lazy!./Spanish/Ptoct';
import loadSpanishAroct from 'bundle-loader?lazy!./Spanish/Aroct';
import loadSpanishXmas from 'bundle-loader?lazy!./Spanish/Xmas';
import loadSpokesman2017 from 'bundle-loader?lazy!./Spokesman/2017';
import loadBattlesSeason2 from 'bundle-loader?lazy!./Battles/Season2';
import loadBattlesSeason3 from 'bundle-loader?lazy!./Battles/Season3';
import loadBattlesSeason4 from 'bundle-loader?lazy!./Battles/Season4';
import loadBattlesSeason5 from 'bundle-loader?lazy!./Battles/Season5';
import loadBattlesDownload from 'bundle-loader?lazy!./Battles/Download';
import loadBattlesDiwali from 'bundle-loader?lazy!./Battles/Diwali';
import loadRamadan2018Skin from 'bundle-loader?lazy!./Ramadan/2018Skin';
import loadRamadan2019 from 'bundle-loader?lazy!./Ramadan/2019';
import loadRamadan2019Skin from 'bundle-loader?lazy!./Ramadan/2019Skin';
import loadRamadanDonation from 'bundle-loader?lazy!./Ramadan/Donation';
import loadSnapHitsIndo2017 from 'bundle-loader?lazy!./SnapHits/Indo2017';
import loadSnaptopicIndo2017 from 'bundle-loader?lazy!./Snaptopic/Indo2017';
import loadChristmas2017Skin from 'bundle-loader?lazy!./Christmas/2017Skin';
import loadIndiaWhatsAppStatus from 'bundle-loader?lazy!./India/WhatsAppStatus';
import loadIndiaRakshaBandhan from 'bundle-loader?lazy!./India/RakshaBandhan';
import loadDanceStar from 'bundle-loader?lazy!./DanceStar';
import loadARcampus from 'bundle-loader?lazy!./ARcampus';
import loadARbattle from 'bundle-loader?lazy!./ARbattle';
import loadARmudan from 'bundle-loader?lazy!./ARmudan';
import loadIGOutbound from 'bundle-loader?lazy!./IGOutbound';
import loadWhatsappStatus from 'bundle-loader?lazy!./WhatsappStatus';
import loadSpanishRoast from 'bundle-loader?lazy!./Spanish/Roast';
import loadSpanishRoast2 from 'bundle-loader?lazy!./Spanish/Roast2';
import loadDiwali2018Skin from 'bundle-loader?lazy!./Diwali/2018Skin';
import loadDiwaliytbtest from 'bundle-loader?lazy!./Diwali/ytbtest';
import loadHalloween from 'bundle-loader?lazy!./Halloween';
import loadBrazilSeason1 from 'bundle-loader?lazy!./Brazil/Season1';
import loadBrazilSeason2 from 'bundle-loader?lazy!./Brazil/Season2';
import loadAR2019 from 'bundle-loader?lazy!./AR/2019';
import loadAR2019skin from 'bundle-loader?lazy!./AR/2019skin';
import loadBattlesLanding from 'bundle-loader?lazy!./Battles/Landing';
import loadBattlesIndiaNewYear from 'bundle-loader?lazy!./Battles/IndiaNewYear';
import loadTurkeyBoost from 'bundle-loader?lazy!./Turkey/Boost';
import loadTurkeyBoost2 from 'bundle-loader?lazy!./Turkey/Boost2';
import loadH5Vote from 'bundle-loader?lazy!./H5/Roast';
import loadScreenshot from 'bundle-loader?lazy!./H5/Screenshot';
import loadImportant from 'bundle-loader?lazy!./SP';
import loadKol from 'bundle-loader?lazy!./SP/Kol';
import loadIcon from 'bundle-loader?lazy!./SP/Icon';
import loadComment from 'bundle-loader?lazy!./Zapee/Comment/';
import loadMusicGuess from 'bundle-loader?lazy!./Zapee/MusicGuess/';
import loadMusicTalent from 'bundle-loader?lazy!./Snaptube/MusicTalent/';
import loadCoronavirus from 'bundle-loader?lazy!./Snaptube/Coronavirus/';
import loadSales from 'bundle-loader?lazy!./Snaptube/Sales/';
import loadPrize from 'bundle-loader?lazy!./Zapee/Prize/';
import loadZapeeCoronavirus from 'bundle-loader?lazy!./Zapee/Coronavirus';
import loadLarkPlayerCoronavirus from 'bundle-loader?lazy!./LarkPlayer/Coronavirus';

const Battle = withBundle(loadBattle);
const Adha2017 = withBundle(loadAdha2017);
const SnapKing = withBundle(loadSnapKing);
const LarkGuide = withBundle(loadLarkGuide);
const LarkParty = withBundle(loadLarkParty);
const Millionaires = withBundle(loadMillionaires);
const LownloadApk = withBundle(lownloadApk);
const JumpMillionaires = withBundle(jumpMillionaires);
const TabMillionaires = withBundle(tabMillionaires);
const WorldCup2018 = withBundle(loadWorldCup2018);
const Christmas2017 = withBundle(loadChristmas2017);
const SpanishBattle = withBundle(loadSpanishBattle);
const SpanishEssept = withBundle(loadSpanishEssept);
const SpanishEssept2 = withBundle(loadSpanishEssept2);
const SpanishEssept3 = withBundle(loadSpanishEssept3);
const SpanishEsoct = withBundle(loadSpanishEsoct);
const SpanishPtoct = withBundle(loadSpanishPtoct);
const SpanishAroct = withBundle(loadSpanishAroct);
const SpanishXmas = withBundle(loadSpanishXmas);
const Spokesman2017 = withBundle(loadSpokesman2017);
const BattlesSeason2 = withBundle(loadBattlesSeason2);
const BattlesSeason3 = withBundle(loadBattlesSeason3);
const BattlesSeason4 = withBundle(loadBattlesSeason4);
const BattlesSeason5 = withBundle(loadBattlesSeason5);
const BattlesDownload = withBundle(loadBattlesDownload);
const BattlesDiwali = withBundle(loadBattlesDiwali);
const Ramadan2018Skin = withBundle(loadRamadan2018Skin);
const Ramadan2019 = withBundle(loadRamadan2019);
const Ramadan2019Skin = withBundle(loadRamadan2019Skin);
const RamadanDonation = withBundle(loadRamadanDonation);
const SnapHitsIndo2017 = withBundle(loadSnapHitsIndo2017);
const SnaptopicIndo2017 = withBundle(loadSnaptopicIndo2017);
const Christmas2017Skin = withBundle(loadChristmas2017Skin);
const IndiaWhatsAppStatus = withBundle(loadIndiaWhatsAppStatus);
const IndiaRakshaBandhan = withBundle(loadIndiaRakshaBandhan);
const DanceStar = withBundle(loadDanceStar);
const ARcampus = withBundle(loadARcampus);
const ARbattle = withBundle(loadARbattle);
const ARmudan = withBundle(loadARmudan);
const AR2019 = withBundle(loadAR2019);
const AR2019skin = withBundle(loadAR2019skin);
const IGOutbound = withBundle(loadIGOutbound);
const WhatsappStatus = withBundle(loadWhatsappStatus);
const SpanishRoast = withBundle(loadSpanishRoast);
const SpanishRoast2 = withBundle(loadSpanishRoast2);
const Diwali2018Skin = withBundle(loadDiwali2018Skin);
const Diwaliytbtest = withBundle(loadDiwaliytbtest);
const Halloween = withBundle(loadHalloween);
const BrazilSeason1 = withBundle(loadBrazilSeason1);
const BrazilSeason2 = withBundle(loadBrazilSeason2);
const BattlesIndiaNewYear = withBundle(loadBattlesIndiaNewYear);
const BattlesLanding = withBundle(loadBattlesLanding);
const TurkeyBoost = withBundle(loadTurkeyBoost);
const TurkeyBoost2 = withBundle(loadTurkeyBoost2);
const Kol = withBundle(loadKol);
const Icon = withBundle(loadIcon);

const H5Vote = withBundle(loadH5Vote);
const Screenshot = withBundle(loadScreenshot);
const Comments = withBundle(loadComment);
const MusicGuess = withBundle(loadMusicGuess);
const MusicTalent = withBundle(loadMusicTalent);
const Coronavirus = withBundle(loadCoronavirus);
const Sales = withBundle(loadSales);
const Important = withBundle(loadImportant);
const Prize = withBundle(loadPrize);
const ZapeeCoronavirus = withBundle(loadZapeeCoronavirus);
const LarkPlayerCoronavirus = withBundle(loadLarkPlayerCoronavirus);

class App extends Component {
  componentDidMount() {
    sensors.init({
      server_url: 'https://sensors.snappea.com/sa?project=GrowthCampaigns',
      // heatmap_url: 'https://intranet.snappea.com/cjv2aqsok0001hk23x0qws6hp',
      // web_url: 'https://sensors.snappea.com/sa?project=GrowthCampaigns',
      heatmap: {
        clickmap: 'default',
        scroll_notice_map: 'not_collect'
      }
    });
    sensors.quick('autoTrack');
    window._spinner.stop();
  }

  // componentDidCatch(error, extra) {
  //   Raven.captureException(error, {extra});
  // }

  render() {
    return (
      <Col
        minHeight="100vh"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif">
        <Switch>
          <Route path="/auth" component={Auth} />
          <Route path="/adha/2017" component={Adha2017} />
          {/* 宰牲节歌单接龙活动 */}
          <Route path="/(snapking|outbound/snapking)" component={SnapKing} />
          {/* SnapKing */}
          <Route path="/spokesman/2017" component={Spokesman2017} />
          {/* Snaptube 代言人活动 */}
          <Route path="/snaphits/indo2017" component={SnapHitsIndo2017} />
          <Route path="/snaptopic" component={SnaptopicIndo2017} />
          <Route path="/larkparty" component={LarkParty} />
          <Route path="/larkguide" component={LarkGuide} />
          <Route
            path="/(xmas2017|outbound/xmas2017)"
            component={Christmas2017}
          />
          <Route path="/xmas/2017skin" component={Christmas2017Skin} />
          {/* 圣诞 UGC 活动 */}
          <Route path="/ramadan/2018skin" component={Ramadan2018Skin} />
          {/* 斋月下载截图活动 */}
          <Route path="/ramadan/2019" component={Ramadan2019} />
          {/* 斋月内容分享/下载 */}
          <Route path="/ramadan/2019skin" component={Ramadan2019Skin} />
          {/* 斋月2019活动包 */}
          <Route path="/ramadan/donation" component={RamadanDonation} />
          {/* 斋月慈善活动 */}
          <Route exact path="/millionaires/download" component={LownloadApk} />
          <Route exact path="/millionaires/jump" component={JumpMillionaires} />
          <Route exact path="/millionaires/tab" component={TabMillionaires} />
          <Route path="/millionaires" component={Millionaires} />
          <Route path="/battle" component={Battle} />
          {/* 红人 Battle 第一季分享截图活动 */}
          <Route path="/worldcup/2018" component={WorldCup2018} />
          {/* 世界杯截图活动 */}
          <Route path="/india/whatsappstatus" component={IndiaWhatsAppStatus} />
          {/* Whatsapp Status 分享截图活动 */}
          <Route path="/india/rakshabandhan" component={IndiaRakshaBandhan} />
          {/* 洒红节自拍活动(兄弟姐妹节？) */}
          <Route path="/spanish/battle" component={SpanishBattle} />
          <Route path="/spanish/essept" component={SpanishEssept} />
          <Route path="/spanish/essept2" component={SpanishEssept2} />
          <Route path="/ar/eid_adha" component={SpanishEssept3} />
          <Route path="/esoct" component={SpanishEsoct} />
          <Route path="/ptoct" component={SpanishPtoct} />
          <Route path="/aroct" component={SpanishAroct} />
          <Route path="/spanish/xmas" component={SpanishXmas} />
          <Route path="/battles/season2" component={BattlesSeason2} />
          {/* 红人 Battle 第二季分享截图活动 */}
          <Route path="/battles/season3" component={BattlesSeason3} />
          {/* 红人 Battle 第三季分享截图活动 */}
          <Route path="/battles/season4" component={BattlesSeason4} />
          <Route path="/battles/season5" component={BattlesSeason5} />
          <Route path="/downloadlanding" component={BattlesDownload} />
          {/* 红人 Battle 第四季分享截图活动 */}
          <Route path="/battles/diwali" component={BattlesDiwali} />
          <Route path="/dancestar" component={DanceStar} />/
          <Route path="/arcampus" component={ARcampus} />
          {/* 校园下载截图活动 */}
          <Route path="/arbattle" component={ARbattle} />
          {/* 红人下载截图活动 */}
          <Route path="/armudan" component={ARmudan} />
          {/* 穆旦节下载截图活动 */}
          <Route path="/newyear" component={AR2019} />
          {/* 新年卡片活动 */}
          <Route path="/2019skin" component={AR2019skin} />
          <Route path="/igoutbound" component={IGOutbound} />
          <Route path="/igoutbound2" component={IGOutbound} />
          <Route path="/whatsappstatus" component={WhatsappStatus} />
          {/* Whatsapp Status 性格测试活动 */}
          <Route path="/esroast" component={SpanishRoast} />
          <Route path="/esroast2" component={SpanishRoast2} />
          {/* R 歌之王 */}
          <Route path="/diwali/2018skin" component={Diwali2018Skin} />
          {/* Diwali 排灯节截图分享活动+皮肤包 */}
          <Route path="/ytbtest" component={Diwaliytbtest} />
          <Route path="/halloween" component={Halloween} />
          {/* 万圣节视频卡片活动 */}
          <Route path="/brazil/season1" component={BrazilSeason1} />
          {/* 巴西红人抽奖送手机活动 */}
          <Route path="/brazil/season2" component={BrazilSeason2} />
          {/* 巴西红人抽奖送手机活动 */}
          <Route path="/indianewyear" component={BattlesIndiaNewYear} />
          <Route path="/battles/landing" component={BattlesLanding} />
          {/* 土耳其助力活动 */}
          <Route path="/boost" component={TurkeyBoost} />
          <Route path="/comment/:id" component={Comments} />
          <Route path="/boost2" component={TurkeyBoost2} />
          <Route path="/h5/roast/:id" component={H5Vote} />
          <Route path="/h5/screenshot" component={Screenshot} />
          <Route path="/kol/:id" component={Kol} />
          <Route path="/icon/:id" component={Icon} />
          <Route path="/:id/roast/share/" component={H5Vote} />
          {/* 猜歌活动 */}
          <Route path="/musicGuess" component={MusicGuess} />
          <Route path="/musicTalent" component={MusicTalent} />
          <Route path="/coronavirus" component={Coronavirus} />
          <Route path="/sales" component={Sales} />
          <Route path="/important" component={Important} />
          <Route path="/prize/:id" component={Prize} />
          <Route path="/zapee/coronavirus" component={ZapeeCoronavirus} />
          <Route
            path="/larkplayer/coronavirus"
            component={LarkPlayerCoronavirus}
          />
        </Switch>
      </Col>
    );
  }
}

const Analysed = withGA(App);

render(
  <BrowserRouter>
    <Analysed />
  </BrowserRouter>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./components/index.js